const MergingArrows = () => (
  <>
    <path
      fill="currentColor"
      d="M5.438 6.247a.5.5 0 0 1 .354-.16.5.5 0 0 1 .353.16l4.666 4.666a.56.56 0 0 0 .423.173h6.898l-2.74-2.74A.5.5 0 0 1 15.236 8a.47.47 0 0 1 .155-.363q.166-.165.357-.166.192 0 .357.166l3.388 3.382a.8.8 0 0 1 .184.268q.053.136.053.298a.8.8 0 0 1-.053.298.8.8 0 0 1-.184.267L16.1 15.545a.5.5 0 0 1-.344.156.47.47 0 0 1-.364-.156.5.5 0 0 1-.165-.356q0-.192.165-.357l2.74-2.746H11.24q-.322 0-.627-.131a1.6 1.6 0 0 1-.523-.348L5.438 6.955a.5.5 0 0 1-.15-.344.47.47 0 0 1 .15-.364m-.006 10.677a.5.5 0 0 1-.16-.354q0-.194.16-.354l2.871-2.877a.5.5 0 0 1 .344-.155.47.47 0 0 1 .364.155.5.5 0 0 1 .165.357.5.5 0 0 1-.165.357L6.14 16.924a.5.5 0 0 1-.342.153.47.47 0 0 1-.366-.153"
    />
  </>
)
export default MergingArrows
